module.exports = __webpack_public_path__ + "static/media/IA.a94e4105.jpg";